<template>
    <div class="zhuanshudingding">
        <div class="banner">
            <div class="banner-btn-box">
                <div class="btn-lis1" @click="clickJumpS1">免费咨询</div>
            </div>
        </div>
        <div class="cont1">
            <p class="title-box-x">领域模型驱动，快速响应业务变化</p>
            <p class="smallss">云枢核心能力为模型驱动开发，实现应用开发对业务变化的快速响应，帮助企业快速响应市场变化。多样化部署能力和云原生架构紧跟科技时代的发展，满足企业对新技术、新业态的诉求。提供四大平台和两大市场，分别为可视化应用开发平台、云枢应用服务运行平台、云枢应用部署&管理服务和AI&大数据平台，云枢应用&资产市场和云枢集成&开放市场。集成支持如钉钉、小程序、SAP及金蝶K3等系统。</p>
            <div class="cssimg">
                <img class="img-kuangjia" src="https://www.authine.com/uploads/20210630081436_904352.png" alt="">
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">为什么选择云枢？</p>
                <div class="line"></div>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">云原生架构</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">微服务化，低耦合</p>
                    </li>
                    <li>
                        <p class="ps1">业务中台</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">满足企业业务中台需要</p>
                    </li>
                    <li>
                        <p class="ps1">领域模型驱动开发</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">支持可视化建模，模型建立后自动生成</p>
                    </li>
                    <li>
                        <p class="ps1">流程引擎</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">拖拽式流程设计，支持流程快速设计</p>
                    </li>
                    <li>
                        <p class="ps1">多样化部署</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">支持公有云、专有云、私有云部署</p>
                    </li>
                    <li>
                        <p class="ps1">资产沉淀与复用</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">提供资产市场，支持公有私有</p>
                    </li>
                    
                    
                </ul>
                
            </div>
        </div>
        <div class="cont2">
            <div class="sssdd"></div>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>
        
<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       },
        jumpYL(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       },
       jumpBuy(){
                              window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       },
       clickJumpS1(){
            window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')
       },
       clickJumpS2(){
            window.open('https://aisite.wejianzhan.com/site/wjzkc6f4/9517af39-7621-4763-97b1-9438d0246fe5?fid=nHcLrHm1rjRsn1f1rHDsnWRYP19xnHR1P7tk&ch=4&bd_vid=nHcLrHm1rjRsn1f1rHDsnWRYP19xnHR1P7tkg1Dsn7tYg1Tvnj6dPH0zrHnd&ch=4&bd_bxst=EiaKwMT00AHb-UZSKfDD02kpV6QpPJKU060000ivGQpb-ze1P0000001wbfvPbfYnYPaPH0zPbRYfYf4rDcvf1m3njRYfHT3wbfsfWN7PWRdfbN5RYdiwR9KwRV2cjPDfRfzwDRknRPDwRm3rDPDnW0kPjK7wj7DnDNjnHmd1aE_DCIwdxRK0000dlnnVkD000KnQ5k2Ws000Kn0Ps02VJivGQj_8pVEmiBvGQpbQU1zVpylsq5jVTHAtq2d_rz4JeMTsrL5VTv1QT5BVqZ2dP5j000Gu-xI')
       },
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url('./banner-pc-img/img-yunshu-banneraas-tuya.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .banner-btn-box{
            width: 300px;
            height: 65px;
            position: absolute;
            left: 50%;
            transform: translate(-150px , 0);
            bottom: 50px;
            .btn-lis1{
                width: 300px;
                height: 65px;
                border-radius: 40px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
                letter-spacing: 4px;
                cursor: pointer;
                background-image: linear-gradient(to right, #a18cd1 0%, #7579ff 100%);
                padding-bottom: 3px;
                margin-right: 50px;
            }
            .btn-lis2{
                width: 250px;
                height: 70px;
                border-radius: 40px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 28px;
                letter-spacing: 4px;
                cursor: pointer;
                background-color: transparent;
                border: 2px solid #fff;
                padding-bottom: 3px;
            }
        }
    }
    .cont1{
        width: 100%;
        padding-top: 40px;
        .box-cont1{
            width: 80%;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 5px 20px 10px rgb(79 122 156 / 22%);
            border-radius: 6px;
            padding: 40px 90px;
            .title-box{
                font-size: 20px;
                color: #000;
                line-height: 40px;
            }
            .con-box{
                font-size: 14px;
                line-height: 25px;
                color:#696969;
            }
            .ul-box{
                width: 100%;
                height: 270px;
                background-color: red;
                margin-top: 23px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 300px;
                    text-align: center;
                    img{
                        width: 100%;
                        height: 138px;
                        
                    }
                    .pp1{
                        font-size:18px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                    }
                    .pp2{
                        font-size:14px;
                        color:#808080;
                        text-align: center;
                        line-height: 22px;
                    }
                }
            }
        }
        // ----
        .title-box-x{
            font-size: 35px;
            color: #000;
            text-align: center;
            padding: 20px;
        }
        .smallss{
            width: 70%;
            margin: auto;
            font-size: 19px;
            color: #707481;
            text-align: center;
            margin-top: 16px;
            padding: 20px;
            font-size: 20px;
            line-height: 30px;
        }
        .cssimg{
            width: 70%;
            margin: auto;
            margin-top: 40px;
            margin-bottom: 40px;
        }   
        .img-kuangjia{
            width: 100%;
            height: 100%;
        }
        
        // ---
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 80%;
                margin: 50px auto;
                margin-bottom: 20px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    width: 32%;
                    background-image: url("./img-info/img-chuanyuan-s5.jpg");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    padding-top: 25px;
                    margin-bottom: 30px;
                    padding: 40px;
                    .ps1{
                        font-size: 26px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        padding: 10px;
                    }
                    .lin-yuanjiao{
                        width: 30px;
                        height: 2px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 25px;
                        margin-top: 13px;
                    }
                    .ps2{
                        font-size: 19px;
                        color:#FFFFFF;
                        text-align: center;
                    }
                }
            }
        }
        
    }
    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 35px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 80%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
                width: 601px;
                height: 240px;
                background-color: #fff;
                transition: all 0.3s linear;
                margin-bottom: 40px;
                .top-hexin{
                    width: 100%;
                    height: 140px;
                    background-color: rgba(237, 240, 246, 1);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 60px;
                        height: 45px;
                        margin-top: 10px;
                    }
                    .title-hexin{
                        font-size: 18px;
                        color: #000;
                        line-height: 36px;
                        text-align: center;
                        margin-top: 15px;
                    }

                }
                .bottom-hexin{
                    width: 100%;
                    height: 100px;
                    background-color: #fff;
                    padding-top: 20px;
                    .p-hexin{
                        font-size: 14px;
                        line-height: 22px;
                        color:#696969;
                        text-align: center;
                    }
                }
            }
            li:hover{
                box-shadow: 0px 0px 20px 15px rgb(0 0 0 / 10%);
            }
        }
        
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 35px;
    text-align: center;
    color: #000;
    line-height: 30px;
}
.line{
   width: 50px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 20px;
 }
 .letter-title{
    font-size: 16px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}

.zhuanjia{
            width: 80%;
             background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
</style>